import {PotDetails} from '../schema-types/PotDetails';

export const POTS_PENSION = 'pension';
export const POTS_GIA = 'gia';
export const POTS_ISA = 'isa';
export const POTS_JISA = 'jisa';
export const POTS_JSIPP = 'pension';
export const POTS_BOND = 'bond';
export const POTS_ACCOUNT = 'account';
export const POTS_GIA_GROSS = 'gia_gross';
export const POTS_CASH = 'cash';
export const POTS_PROTECTION = 'protectionPlan';
export const POTS_ANNUITY = 'annuity';

export const PLAN_FILTERS = [POTS_ACCOUNT, POTS_BOND, POTS_GIA, POTS_ISA, POTS_PENSION];
export const BANK_CURRENT_ACCOUNT = 'Bank current account';

/**
 * returns a substring to use when determining if a string relates to a pot
 * @param {string} mainPlanType
 * @returns {string}
 */
export const getPotsFilter = (mainPlanType: string): string => {
  let filter;
  switch (mainPlanType) {
    case POTS_PENSION:
      filter = 'Pension';
      break;
    case POTS_GIA:
      filter = 'General Investment Account';
      break;
    case POTS_BOND:
      filter = 'Bond';
      break;
    case POTS_ISA:
      filter = 'ISA';
      break;
    case POTS_ACCOUNT:
      filter = 'Bank current account';
      break;
    case POTS_ANNUITY:
      filter = 'Pension'; // Annuities source from pension plans
      break;
    default:
      filter = '';
      break;
  }
  return filter;
};

export const CASH_OBJ = {id: POTS_CASH};

export const isBankAccount = (pot: PotDetails): boolean =>
  pot?.productName?.formattedName === BANK_CURRENT_ACCOUNT;

/**
 * Plan statuses that represent an active, selectable plan. Mirrors the backend
 * `ACTIVE_PLAN_STATUSES` in `saltus/oneview/models/pot.py` (the `only_active_plans`
 * filter). Stored lower-cased and compared case-insensitively.
 */
export const ACTIVE_PLAN_STATUSES = ['in force', 'proposed'];

/**
 * Whether a plan may be offered as a contribution source. A plan is excluded only
 * when it carries an explicit, non-active status (e.g. Lapsed, Surrendered,
 * Transferred). A missing status — a newly added / not-yet-synced plan — is treated
 * as active, matching how the backend leaves new plans selectable.
 *
 * See ON-9350 / ON-9097: inactive plans were pulling through to the source picker
 * because the contribution flow reads the unfiltered destination payload.
 */
export const isSelectableSourcePlanStatus = (planStatus?: string | null): boolean =>
  !planStatus || ACTIVE_PLAN_STATUSES.includes(planStatus.toLocaleLowerCase());

/**
 * gets the ID of the nominated account of a given product
 * @param {array} arr a product array
 * @param {string} selectedId the product ID
 * @returns {string}
 */
export const getDefaultAccountId = (arr: Array<any>, selectedId: string): string =>
  arr.find((x) => x.id === selectedId)?.nominatedAccount?.id;

export const getPotsLabel = (mainPlanType: string): string => {
  switch (mainPlanType) {
    case POTS_PENSION:
      return 'Pension';
    case POTS_GIA:
      return 'GIA';
    case POTS_BOND:
      return 'Bond';
    case POTS_ISA:
      return 'ISA';
    case POTS_ACCOUNT:
      return 'Bank account';
    case POTS_ANNUITY:
      return 'Annuity';
    case POTS_JSIPP:
      return 'Jnuior SIPP';
    default:
      return mainPlanType;
  }
};
